---
de:
  data_export:
    budget_revenue: Budgeterlös
    budget_volume: Budgetmenge
    downtime_comment: Stillstandskommentare
    downtime_cost: Stillstandskosten
    downtime_reason: Gründe für den Stillstand
    downtime_volume: Stillstandsmenge
    from_date: Von Datum
    heading: Stündliche Werte in eine Tabelle exportieren
    individual_power_plants: Einzelne Kraftwerke auswählen
    missing_exchange_rate_error: Wechselkursdaten fehlen für den ausgewählten Zeitraum und die Währung. Bitte kontaktieren Sie den Support.
    pending_email: Die Tabelle wird per E-Mail versendet, sobald sie fertig ist.
    power_plants: Kraftwerke
    price_areas: Alle Kraftwerke im Preisbereich auswählen
    prices: Preise
    rate_limited: Zu viele Anfragen
    ready_notification:
      body: Klicken Sie auf Anzeigen, um die Tabelle herunterzuladen.
      title: Ihr Datenexport ist fertig
    report:
      budget_revenue:
        report_sheet_header: Erlös
        report_sheet_name: Budgeterlös
        summary_sheet_header: Budgeterlös %{currency}
      budget_volume:
        report_sheet_header: MWh
        report_sheet_name: Budgetmenge
        summary_sheet_header: Budgetmenge MWh
      downtime_comment:
        report_sheet_header: Kommentare
        report_sheet_name: Stillstandskommentare
      downtime_cost:
        report_sheet_header: Kosten
        report_sheet_name: Stillstandskosten
        summary_sheet_header: Gesamtkosten bei Stillstand %{currency}
      downtime_reason:
        report_sheet_header: Grund
        report_sheet_name: Grund für den Stillstand
      downtime_volume:
        report_sheet_header: MWh
        report_sheet_name: Stillstandsmenge
        summary_sheet_header: Gesamtmenge bei Stillstand MWh
      monthly_sheet_left_header: Kraftwerk
      monthly_sheet_sum_header: SUMME
      monthly_sheet_title: Monatszusammenfassung
      monthly_sheet_top_header: Zeitraum
      prices:
        report_sheet_header: Preise
        report_sheet_name: Preise
        summary_sheet_header: Preise (%{currency})
      report_sheet_left_headers:
      - Zeitzone
      - Stunde
      revenue:
        report_sheet_header: Erlös
        report_sheet_name: Erlös
        summary_sheet_header: Bruttoerlös %{currency}
      summary_sheet_left_header: Datenexport
      summary_sheet_title: Zusammenfassung
      summary_sheet_top_header: Zeitraum
      volume:
        report_sheet_header: MWh
        report_sheet_name: Menge
        summary_sheet_header: Produktionsmenge MWh
    report_types: Berichtstypen
    revenue: Erlös
    select_power_plants: Wählen Sie Kraftwerke aus
    to_date: Bis Datum
    volume: Menge
  errors:
    messages:
      export_too_large: Der Export ist zu groß. Bitte versuchen Sie es mit einem kleineren Datensatz.
      no_power_plants_selected: Keine Kraftwerke ausgewählt
